import { EpimsBaseEntityDto } from './epim-base.dto';
export class SuitProgressDto extends EpimsBaseEntityDto {

    SuitProgressId: string;
    AdrId: string;
    SuitNo: string;   
    ProgressDate: string;
    ProgressRemarks: string;
    SuitStatus: string;
    InputStaff: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}